export const TNT_PROD_DOMAIN = {
  ko: "https://thisisneverthat.com/",
  en: "https://intl.thisisneverthat.com/",
  jp: "https://thisisneverthat.jp/",
};

export const TNT_PREVIEW_DOMAIN = {
  ko: "https://d257kvs4acsh7t.cloudfront.net/",
  en: "https://dgklsgs33ap3q.cloudfront.net/",
  jp: "https://thisisneverthat.jp/",
};

export const KHAKIS_DOMAIN = {
  ko: "https://khakis2020.com/",
  en: "https://intl.khakis2020.com/",
};

export const KHAKIS_PREVIEW_DOMAIN = {
  ko: "https://dwrfxnpm4r3ng.cloudfront.net/",
  en: "https://d3940oxfqzibdp.cloudfront.net/",
};

export const YESEYESEE_DOMAIN = {
  ko: "https://yeseyesee.com/",
  en: "https://intl.yeseyesee.com/",
};

export const YESEYESEE_PREVIEW_DOMAIN = {
  ko: "https://d22ko224tg0dag.cloudfront.net/",
  en: "https://d3svuqvgzrcjph.cloudfront.net/",
};

export const SUNLOVE_DOMAIN = {
  ko: "https://khakis2020.com/",
  en: "https://intl.khakis2020.com/",
};

export const SUNLOVE_PREVIEW_DOMAIN = {
  ko: "https://dwrfxnpm4r3ng.cloudfront.net/",
  en: "https://d3940oxfqzibdp.cloudfront.net/",
};

export const TUNE_PROD_DOMAIN = "https://tune.kr/";
export const TUNE_PREVIEW_DOMAIN = "https://d3izttcuyjut7x.cloudfront.net/";
export const TUNE_ARCHIVE_SALE_DOMAIN = "https://archive-sale.tune.kr/";
export const TUNE_ARCHIVE_SALE_CLOUDFRONT_DOMAIN =
  "https://d1hikmnu6twm78.cloudfront.net/";

export const WBE_DOMAIN = "https://wellbeingexpress.com/";
export const WBE_PREVIEW_DOMAIN = "https://d3dm36am9619rt.cloudfront.net/";

export type TLocale = "ko" | "en" | "jp";

export const STORE_DOMAIN = {
  thisisneverthat: { prod: TNT_PROD_DOMAIN, preview: TNT_PREVIEW_DOMAIN },
  khakis: { prod: KHAKIS_DOMAIN, preview: KHAKIS_PREVIEW_DOMAIN },
  yeseyesee: { prod: YESEYESEE_DOMAIN, preview: YESEYESEE_PREVIEW_DOMAIN },
  sunlove: { prod: SUNLOVE_DOMAIN, preview: SUNLOVE_PREVIEW_DOMAIN },
  tune: { prod: TUNE_PROD_DOMAIN, preview: TUNE_PREVIEW_DOMAIN },
  wellbeingexpress: { prod: WBE_DOMAIN, preview: WBE_PREVIEW_DOMAIN },
} as const;

export type TStoreName = keyof typeof STORE_DOMAIN;

export interface IDomainInfo {
  locale: TLocale | null;
  isPreview: boolean;
}

const matchLocale = (
  href: string,
  domain: string | Partial<Record<TLocale, string>>,
): TLocale | null => {
  if (typeof domain === "string") return href.includes(domain) ? "ko" : null;

  return (
    (Object.keys(domain) as TLocale[]).find((locale) =>
      href.includes(domain[locale] ?? ""),
    ) ?? null
  );
};

// 스토어명과 현재 접속 url로 프리뷰 여부 판별
export const getDomainInfo = (store: TStoreName, href: string): IDomainInfo => {
  const { prod, preview } = STORE_DOMAIN[store];

  const prodLocale = matchLocale(href, prod);
  if (prodLocale) return { locale: prodLocale, isPreview: false };

  const previewLocale = matchLocale(href, preview);
  if (previewLocale) return { locale: previewLocale, isPreview: true };

  return { locale: null, isPreview: false };
};
